module.exports = __webpack_public_path__ + "media/images/color_admin_v3/user-2-96173b2796436098f71d4093e538c6c2.jpg";